import { Observable } from 'rxjs';
/**
 * This is just an interface describing the class
 * Unfortunately Typescript "Interfaces" don't actually work like java interfaces
 * so we have to use empty classes as interface. Typescript Interfaces can't be
 * used in the Angular Module 'providers' array
 */
export class InformationInterface {
    /**
     * todo maybe every method could be specific in the typ of Observable it
     * returns, so getStopsForName could return Observable<TrafficNode[]>
     */
    getTrafficNodesForStringInput(params) {
        return new Observable();
    }
    getConnections(params) {
        return new Observable();
    }
    getEarlierConnections(params) {
        return new Observable();
    }
    getLaterConnections(params) {
        return new Observable();
    }
    getTimetableEvents(params) {
        return new Observable();
    }
    getEarlierTimetableEvents(params) {
        return new Observable();
    }
    getLaterTimetableEvents(params) {
        return new Observable();
    }
    getStopsForCoords(params) {
        return new Observable();
    }
    getAvailableTickets(params) {
        return new Observable();
    }
    getMapNodes(params) {
        return new Observable();
    }
    getTrafficMessages(params) {
        return new Observable();
    }
    getLines(params) {
        return new Observable();
    }
}
//# sourceMappingURL=informationInterface.interface.js.map